import { useMemo } from 'react';
import { ADMIN, BRISTEC_ADMIN, MODERATOR } from '../../../const/constants';
import { useAuth } from '../../../hooks/useAuth';
import type { BankingDto } from '../types/BankingDto';

export const PERMISSION_MESSAGE = 'You do not have the required permissions';
export const PROCESSED_MESSAGE = 'Record has been processed';

export function useBankingAuth(rearDisplay: BankingDto) {
	const auth = useAuth();

	const authMessage = useMemo(() => {
		if (![MODERATOR, ADMIN, BRISTEC_ADMIN].includes(auth.getRole()))
			return PERMISSION_MESSAGE;
	}, []);

	const processedMessage = useMemo(() => {
		if (rearDisplay.processed) return PROCESSED_MESSAGE;
	}, [[rearDisplay.processed]]);

	return { authMessage, processedMessage };
}
